import { forwardRef, useRef, useImperativeHandle } from 'react';
import cn from 'bem-cn';

import { ValidationWrapper } from '../ValidationWrapper/ValidationWrapper';
import { useAutoResize } from '../../../hooks';
import { TextAreaProps } from './TextArea.types';

import './TextArea.scss';

const b = cn('textarea');

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
    ({ className, error, value, size = 'big', autoResize = false, disabled = false, ...props }, ref) => {
        const textareaRef = useRef<HTMLTextAreaElement>(null);

        // Используем хук для автоматического изменения размера, если включен autoResize
        useAutoResize(textareaRef as React.RefObject<HTMLTextAreaElement>, autoResize ? value : undefined, {
            minHeight: size === 'big' ? 268 : 54,
        });

        // Пробрасываем ref наружу
        useImperativeHandle(ref, () => textareaRef.current as HTMLTextAreaElement);

        return (
            <ValidationWrapper error={error}>
                <textarea
                    ref={textareaRef}
                    className={b({ error: Boolean(error), size, disabled })}
                    value={value}
                    rows={1}
                    disabled={disabled}
                    {...props}
                />
            </ValidationWrapper>
        );
    },
);
